import { AimSignalStateStore } from 'app/stores/AimSignalStateStore';

export const canUpdateConditionId = (aimSignalStateStore: AimSignalStateStore) => {
  if (!aimSignalStateStore.newConditionId || aimSignalStateStore.newConditionId === window?.ostro?.conditionId) {
    return false;
  }

  if (aimSignalStateStore.isTailorManuallyClosed) {
    return true;
  }

  if (aimSignalStateStore.hasExternalLinkBeenClicked) {
    return true;
  }

  return false;
};
